<template>
  <div class="medicine-component">
    <!-- <div :class="{'content-form-container':true,'readonly':!editObj.edit}"> -->
    <el-form :model="form" :rules="rules" ref="form" class="form">
      <el-form-item label="渔药名称" :label-width="formLabelWidth" prop="name">
        <el-input
          v-model="form.name"
          :disabled="!editObj.edit"
          placeholder="请输入渔药名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="渔药类型" :label-width="formLabelWidth" prop="type">
        <el-select
          v-model="form.type"
          filterable
          :disabled="!editObj.edit"
          placeholder="请选择渔药类型"
        >
          <el-option
            v-for="(item, index) in medicineList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计量单位" :label-width="formLabelWidth" prop="unit">
        <el-select
          v-model="form.unit"
          filterable
          :disabled="!editObj.edit"
          placeholder="请选择计量单位"
        >
          <el-option
            v-for="(item, index) in measurementUnitList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="规格" :label-width="formLabelWidth" prop="spec">
        <el-input
          v-model="form.spec"
          :disabled="!editObj.edit"
          placeholder="请输入规格"
        ></el-input>
      </el-form-item>
      <el-form-item label="单价" :label-width="formLabelWidth" prop="purchaseMoney">
        <el-input
          v-model="form.purchaseMoney"
          :disabled="!editObj.edit"
          placeholder="请输入单价"
          type="number"
        ></el-input>
      </el-form-item>
      <el-form-item prop="photoUrl" label="渔药图片">
        <el-upload
          :disabled="!editObj.edit"
          :class="{ yuyaoHide: hideUpload }"
          :action="uploadImgUrl"
          :data="qiniuData"
          list-type="picture-card"
          :on-preview="imgPreview"
          :on-success="imgSuccess"
          :on-change="imgChange"
          :on-remove="imgRemove"
          :before-upload="imgBefore"
          :limit="uploadLimit"
          :headers="headers"
          :file-list="imgList"
          ref="imgUpload"
        >
          <i class="el-icon-plus">
            <h4 class="upload-tip"></h4>
          </i>
          <el-dialog :visible.sync="isShowImgDialog" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-upload>
      </el-form-item>
    </el-form>
    <div
      class="dialog-footer"
      v-if="$store.state.curCompany.isQlwVersion === true"
    >
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button
        type="primary"
        @click="save('form')"
        v-if="titleName !== '添加物资信息'"
        >保 存</el-button
      >
      <el-button
        type="primary"
        @click="saveEditData('form')"
        v-if="titleName === '编辑渔药信息'"
        >保 存</el-button
      >
    </div>
    <div
      class="dialog-footer"
      v-if="$store.state.curCompany.isQlwVersion !== true && editObj.edit"
    >
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button
        style="width: 110px"
        type="primary"
        @click="save('form', 'saveAndReset')"
        >保存后新增</el-button
      >
      <el-button
        type="primary"
        @click="save('form')"
        v-if="titleName !== '添加物资信息'"
        >保 存</el-button
      >
      <el-button
        type="primary"
        @click="saveEditData('form')"
        v-if="titleName === '编辑渔药信息'"
        >保 存</el-button
      >
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../../store";
export default Vue.extend({
  name: "MedicineComponent",
  props: {
    dialogObj: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      // 可上传数量
      uploadLimit: 1,
      // 上传添加头部信息
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        method: "post",
      },
      // 图片服务器上传地址
      uploadImgUrl: "https://up-z2.qiniup.com",
      qiniuData: {
        token: "",
        key: "",
      },
      photoName: "",
      // 图片列表
      imgList: [],
      // 图片预览框
      dialogImageUrl: "",
      isShowImgDialog: false,
      // 是否隐藏图片上传框
      hideUpload: false,
      titleName: "",
      activeName: "first",
      formLabelWidth: "90px",
      form: {
        name: "",
        fishStockAbstract: 10002,
        unit: "",
        scaling: "1",
        type: "",
        spec: "",
        photoUrl: "",
      },
      medicineList: [],
      measurementUnitList: [],
      rules: {
        name: [
          {
            required: true,
            message: "请输入渔药名称",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "请先选择渔药类型",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请先选择计量单位",
            trigger: "blur",
          },
        ],
        spec: [
          {
            required: true,
            message: "请输入规格",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(modules.materialSetting, [
      "materialSettingList",
      "dialogFormVisible",
      "editObj",
    ]),
  },
  async mounted() {
    this.medicineList = await this.getMedicineUnit(); // 获取渔药类型
    this.measurementUnitList = await this.getMeasurementUnit(); // 获取计量单位
    // this.form = await this.getMaterialView(50);
    if (this.editObj.category == "渔药") {
      this.form = await this.getMaterialView(this.editObj.id);
      if (this.form.photoUrl) {
        this.hideUpload = true;
        this.imgList = [
          {
            name: this.form.photoUrl,
            url: this.form.photoUrl,
          },
        ];
      } else {
        this.hideUpload = false;
        this.imgList = [];
      }
    }
    this.getToken();
  },
  methods: {
    ...mapActions(modules.dataDict, ["getMedicineUnit", "getMeasurementUnit"]), //计量单位
    ...mapActions(modules.materialSetting, [
      "getMaterialSettingData", //查询
      "delMaterialSettingList", //删除
      "addMaterialSetting", //添加
      "getMaterialView",
      "updateMaterial",
    ]),
    ...mapMutations(modules.materialSetting, ["setDialogFormVisible"]),
    // 上传图片
    async getToken() {
      let res = await this.$api.getToken();
      if (res.data.code == 0) {
        let token = res.data.data;
        this.qiniuData.token = token;
      }
    },
    imgBefore() {
      this.qiniuData.key = this.guid();
    },
    // 图片上传成功
    imgSuccess(response) {
      this.photoName = "https://nfs.nxin.com/" + response.key;
      this.form.photoUrl = this.photoName;
    },

    // 图片上传改变
    imgChange(file, fileList) {
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片移除
    imgRemove(file, fileList) {
      if (fileList.length == 0) {
        this.imgList = [];
        this.form.photoUrl = "";
      }
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片预览
    imgPreview(file) {
      this.dialogImageUrl = file.url;
      this.isShowImgDialog = true;
    },
    findNameByid(index) {
      if (this.measurementUnitList.length > 0 && typeof index == "number") {
        let obj = this.measurementUnitList.find((item) => {
          return item.id == index;
        });
        if (obj) {
          return obj.name;
        }
      }
      if (this.medicineList.length > 0) {
        let obj = this.medicineList.find((item) => {
          return item.id == index;
        });
        if (obj) {
          return obj.name;
        }
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    save(formName, isSaveAndReset) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          if (this.editObj.id) {
            this.form.id = this.editObj.id;
            this.updateMaterial(this.form).then(() => {
              // this.setDialogFormVisible(false);
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$emit("update");
              if (isSaveAndReset === 'saveAndReset') {
                this.saveAndResetFn(this.form.unit)
              } else {
                this.setDialogFormVisible(false);
              }
            }).catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error",
                });
              });
          } else {
            this.addMaterialSetting(this.form)
              .then(() => {
                // this.setDialogFormVisible(false);
                this.$message({
                  message: "保存成功",
                  type: "success",
                });
                this.$emit("update");
                if (isSaveAndReset === 'saveAndReset') {
                  this.saveAndResetFn(this.form.unit)
                } else {
                  this.setDialogFormVisible(false);
                }
              })
              .catch((err) => {
                this.$Alert.info({
                  content: err.response.data,
                  duration: 5000,
                  status: "error",
                });
                // this.$message({
                //   message: "保存失败",
                //   type: "error"
                // });
              });
          }
        }
      });
    },
    cancel() {
      this.setDialogFormVisible(false);
      console.log("quxiao");
    },
    saveAndResetFn(unit){
      this.editObj.id = ''
      this.form = {
        id: "",
        name: "",
        fishStockAbstract: 10002,
        unit,
        scaling: "1",
        type: "",
        spec: "",
        photoUrl: "",
      }
    }
  },
});
</script>
<style lang="stylus">
.yuyaoHide{
  .el-upload{
    display: none;
  }
}
.medicine-component
  .el-form-item__content{
    margin-left:120px!important
    .el-input{
      width:500px;
    }
  }
  .el-upload--picture-card {
    margin-left: 12px;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    margin-left: 12px;
  }
  .el-form .el-form-item .el-form-item__label:before
    position:absolute;
    top: 2px;
    left: 0px;
    color:red;
  .el-form .el-form-item .el-form-item__label
    padding-left:20px;
</style>
